import React from 'react';
import PropTypes from 'prop-types';
// common components
import CustomAvatar from './../../../common/Avatar/Avatar';
import CustomButton from './../../../common/Forms/CustomButton/CustomButton';
import Loader from './../../../common/Loader/Loader';
import './UserList.scss';
const UserList = ({ userList, manageUser }) => { 	
	if (userList && userList.length > 0) {
		return (
			<div className="UserList">
				{userList.map(item =>
					<div className="row card-view" key={item.id}>
						<div className="col col-lg-3 card-heading one">
							<CustomAvatar name={`${item.firstname} ${item.lastname}`} />
							<div className="heading">
								<div className="title" onClick={() => {}}>{item.firstname}&nbsp;{item.lastname}</div>
							</div>
						</div>
						<div className="col-12 col-lg details two">
							<div className="row card-detail">
                				<div className="col col-md-4 col-lg">
									<div className="title">E-mail</div>
									<div className="value">{item.email}</div>
								</div>		
							</div>
						</div>
						<div className="col cardview-actions three">
							<div className="line" />
							<CustomButton
								iconOnly
								iconName='edit'														
								onClick={() => manageUser(true, 'edit', item.id)}
							/>
							<CustomButton
								iconOnly
								iconName='delete'									
								onClick={() => manageUser(true, 'delete', item.id)}
							/>
						</div>
					</div>
				)}
			</div>
		);
	}
	return (<Loader />);
}

UserList.propTypes = {
	userList: PropTypes.instanceOf(Array),
	manageUser: PropTypes.func
};

UserList.defaultProps = {
	userList: [],
	manageUser: () => { }
};

export default UserList;




// WEBPACK FOOTER //
// ./components/User/UserList/UserList.js